import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AddOrderFormValues } from "../../Interfaces/callOptionsInterfaces";

export interface OrderSliceState {
  addOrderFormValues: AddOrderFormValues | null;
  orderTableFetchDataFlag: boolean;
  tradeTableFetchDataFlag: boolean;
}

const initialState: OrderSliceState = {
  addOrderFormValues: null,
  orderTableFetchDataFlag: false,
  tradeTableFetchDataFlag: false,
};

const BCSOrderSlice = createSlice({
  name: "bcdOrder",
  initialState,
  reducers: {
    setAddOrderFormValues: (
      store,
      action: PayloadAction<AddOrderFormValues>
    ) => {
      if (store.addOrderFormValues !== action.payload)
        store.addOrderFormValues = action.payload;
    },
    setOrderTableFetchDataFlag: (store, action: PayloadAction<boolean>) => {
      if (store.orderTableFetchDataFlag !== action.payload)
        store.orderTableFetchDataFlag = action.payload;
    },
    setTradeTableFetchDataFlag: (store, action: PayloadAction<boolean>) => {
      if (store.tradeTableFetchDataFlag !== action.payload)
        store.tradeTableFetchDataFlag = action.payload;
    },
  },
});

export const {
  setAddOrderFormValues,
  setOrderTableFetchDataFlag,
  setTradeTableFetchDataFlag,
} = BCSOrderSlice.actions;
export default BCSOrderSlice.reducer;
